import { ReactNode, useEffect, useRef } from "react";

import * as FancyboxUI from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const { Fancybox: NativeFancybox } = FancyboxUI;

export type FancyBoxProps = {
  children?: ReactNode;
  options?: any;
  delegate?: string;
  className?: string;
};

export function FancyBox(props: FancyBoxProps) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const delegate = props.delegate || "[data-fancybox]";

    NativeFancybox.bind(container, delegate, props.options);

    return () => {
      NativeFancybox.unbind(container);
      NativeFancybox.close();
    };
  });

  return (
    <div ref={containerRef} className={props.className}>
      {props.children}
    </div>
  );
}
